import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';
@Injectable({
  providedIn: 'root'
})
export class UserPayshapAccountService {

  constructor(private http: HttpClient) {}

  postPayshapAccount(userSession: string, bankId: string, accountNumber: string, requestType: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    const request = {
      bankId,
      accountNumber,
      requestType
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/UserBankAccount/add-account`,
      request,
      {
        headers
      }
    );
  }
}